export const MYASA_SQT = 'myasasqt';
export const MYASA_INFO = 'myasainfo';
export const PUB_NEWS = `/${MYASA_INFO}/portal/pub/news`;
export const MYASAINFO_PORTAL = `/${MYASA_INFO}/portal`;
